module.exports = __webpack_public_path__ + "img/nz.8aa9b6c1.png";